import axios, { AxiosInstance } from 'axios'
import {
  FeatureFlagBase,
  FeatureFlagStatesType,
  FeatureFlag,
  FeatureFlagName,
} from './types'

const createClient = (): AxiosInstance => {
  const baseURL = process.env.REACT_APP_CLOUD_FUNCTION_ROOT

  if (!baseURL) {
    console.warn('[FeatureFlags] REACT_APP_CLOUD_FUNCTION_ROOT is not defined')
  }

  const client = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  })

  // Parse response data
  client.interceptors.response.use(
    response => {
      const allowedFlagNames = Object.values(FeatureFlagName)
      const filterData = (data: Record<string, boolean>) => {
        return Object.keys(data).reduce((acc: Record<FeatureFlagName, boolean>, key: string) => {
          if(allowedFlagNames.includes(key as FeatureFlagName)) {
            acc[key as FeatureFlagName] = data[key]
          }
          return acc
        }, {} as Record<FeatureFlagName, boolean>)
      }


      if (!response.data) {
        return Promise.reject(new Error('Invalid response data'))
     }
      if (typeof response.data === 'object') {
        return {
          ...response,
          data: filterData(response.data),
        }
      }
      try {
        const parsedData = JSON.parse(response.data)
        return {
          ...response,
          data: filterData(parsedData),
        }
      } catch (e) {
        console.error('[FeatureFlags API Error]', e)
        throw new Error('Invalid response data')
      }
    },
    error => {
      console.error('[FeatureFlags API Error]', error)
      return Promise.reject(error)
    }
  )

  return client
}

const client = createClient()

export const checkFeatureFlag = (
  name: string,
  strategies?: Record<string, string>
): Promise<FeatureFlagBase> => {
  const strategiesParams = Object.entries(strategies ?? {}).reduce(
    (acc, [key, val]) => ({
      ...acc,
      [`strategies[${key}]`]: val,
    }),
    {} as Record<string, string>
  )

  return client
    .get<FeatureFlagBase>('miscGroup-checkFeatureFlag', {
      params: { name, ...strategiesParams },
    })
    .then(response => response.data)
}

export const checkFeatureFlags = (
  strategies?: Record<string, string>
): Promise<FeatureFlagStatesType> => {
  const strategiesParams = Object.entries(strategies ?? {}).reduce(
    (acc, [key, val]) => ({
      ...acc,
      [`strategies[${key}]`]: val,
    }),
    {} as Record<string, string>
  )

  return client
    .get<FeatureFlagStatesType>('miscGroup-checkFeatureFlags', {
      params: { ...strategiesParams },
    })
    .then(response => response.data)
}

export const getFeatureFlag = (name: string): Promise<FeatureFlag> => {
  return client
    .get<FeatureFlag>('miscGroup-getFeatureFlag', {
      params: { name },
    })
    .then(response => response.data)
}

export const getFeatureFlags = (): Promise<FeatureFlag[]> => {
  return client
    .get<FeatureFlag[]>('miscGroup-getFeatureFlags')
    .then(response => response.data)
}

